import React, { useMemo, useState } from 'react'
import { Image, Pagination, Alert } from 'antd'
import { LegalDocumentType } from 'types'

// PDF WORKER
import { pdfjs } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`
import { Document, Page } from 'react-pdf'
import styled from 'styled-components'

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.js',
//   import.meta.url
// ).toString()

interface IProps {
  side: string
  document: LegalDocumentType
}

const SideDetails = (props: IProps) => {
  const { side, document } = props
  const [numPages, setNumPages] = useState(1)
  const [pageNumber, setPageNumber] = useState(1)
  const [pdfError, setPdfError] = useState<string | null>(null)
  const pdfOptions = useMemo(() => ({ withCredentials: true }), [])

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setPdfError(null)
    setNumPages(numPages)
  }

  const onDocumentLoadError = (error: Error) => {
    console.error('PDF load error:', error)
    setPdfError(error.message || 'Impossible de charger le PDF')
  }

  if (document == null) {
    return <></>
  }

  const fileUrl = document[side == 'verso' ? 'fileVerso' : 'fileRecto']

  const fileIsImage = (file: string) => {
    const imgExts = ['png', 'jpg', 'jpeg']
    const [cleanUrl] = file.toLowerCase().split('?')
    const [extension] = cleanUrl.split('.').slice(-1)

    return imgExts.includes(extension)
  }

  const fileIsPdf = (file: string) => {
    const [cleanUrl] = file.split('?')
    const [extension] = cleanUrl.split('.').slice(-1)

    return extension == 'pdf'
  }

  const handlePageChange = (page: number) => {
    setPageNumber(page)
  }

  return (
    <div>
      {fileIsImage(fileUrl) && (
        <DocumentPreviewWrapperImg>
          <br />
          <Image width={'95%'} src={fileUrl} />
        </DocumentPreviewWrapperImg>
      )}
      {fileIsPdf(fileUrl) && (
        <DocumentPreviewWrapperPdf>
          {pdfError ? (
            <>
              <Alert type="error" message={pdfError} style={{ margin: 8 }} />
              <a
                href={fileUrl}
                target="_blank"
                rel="noreferrer"
                style={{ padding: 8 }}
              >
                Ouvrir le PDF dans un nouvel onglet
              </a>
            </>
          ) : (
            <>
              <Pagination
                simple
                current={pageNumber}
                defaultCurrent={pageNumber}
                defaultPageSize={1}
                onChange={handlePageChange}
                total={numPages}
              />
              <DocumentPreviewPdf>
                <Document
                  file={fileUrl}
                  options={pdfOptions}
                  onLoadSuccess={onDocumentLoadSuccess}
                  onLoadError={onDocumentLoadError}
                >
                  <Page
                    pageNumber={pageNumber}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                  />
                </Document>
              </DocumentPreviewPdf>
              <Pagination
                simple
                current={pageNumber}
                defaultCurrent={pageNumber}
                defaultPageSize={1}
                onChange={handlePageChange}
                total={numPages}
              />
            </>
          )}
        </DocumentPreviewWrapperPdf>
      )}
    </div>
  )
}

export default SideDetails

const DocumentPreviewWrapperImg = styled.div`
  max-width: 1000px;
  display: flex;
  flex-flow: column;
  align-items: center;
  background-color: #eee;
`

const DocumentPreviewWrapperPdf = styled.div`
  max-width: 1000px;
  display: flex;
  flex-flow: column;
  align-items: center;
  background-color: #eee;

  .react-pdf__Page__canvas {
    margin: 0 auto;
    width: 100% !important;
    height: auto !important;
  }
`

const DocumentPreviewPdf = styled.div`
  width: 95%;
`
